import { useApolloClient, useMutation } from '@apollo/client/react';
import { isDefined } from 'app-shared/utils';
import { useCallback } from 'react';
import { SKIP_ERROR_TOAST_CONTEXT } from '@/apollo/constants/SkipErrorToastContext';
import {
  type CreateInterventionInput,
  CreateInterventionDocument,
  GetInterventionsDocument,
  GetPlanningBoardDocument,
  type InterventionFieldsFragment,
} from '~/generated/graphql';
export const useCreateIntervention = () => {
  const client = useApolloClient();
  const [mutate] = useMutation(CreateInterventionDocument);
  const createIntervention = useCallback(
    async (input: CreateInterventionInput) => {
      let intervention: InterventionFieldsFragment | null = null;
      try {
        const { data, error } = await mutate({
          variables: { input },
          errorPolicy: 'all',
          context: SKIP_ERROR_TOAST_CONTEXT,
        });
        intervention = data?.createIntervention ?? null;
        if (!isDefined(intervention))
          return { intervention, error, refreshError: undefined };
        try {
          await client.refetchQueries({
            include: [GetInterventionsDocument, GetPlanningBoardDocument],
          });
          return { intervention, error, refreshError: undefined };
        } catch (refreshError) {
          return { intervention, error, refreshError };
        }
      } catch (error) {
        return { intervention, error, refreshError: undefined };
      }
    },
    [client, mutate],
  );
  return { createIntervention };
};
